export default __webpack_public_path__ + "static/media/close.0ddb40e7.png";